import importer from 'common/importer'
const { oktaReq: req } = importer('APIs', null)
/**
 * Changes a user's password by validating the user's current password
 * @param {String} id `REQUIRED`
 * @param {String} api_token `REQUIRED`
 * @param {String} oldPassword `REQUIRED`
 * @param {String} newPassword `REQUIRED`
 */
export const changePassword = (id, api_token, oldPassword, newPassword) => {
  const data = {
    oldPassword: { value: oldPassword },
    newPassword: { value: newPassword }
  }
  const config = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `SSWS ${api_token}`
    }
  }
  return req.post(`/users/me/${id}/credentials/change_password`, data, config)
}
/**
 * Changes a user's recovery question & answer credential by validating the user's current password
 * @param {String} id `REQUIRED`
 * @param {String} api_token `REQUIRED`
 * @param {String} currentPassword `REQUIRED`
 * @param {String} recoveryQuestion `REQUIRED`
 * @param {String} recoveryAnswer `REQUIRED`
 */
export const changeRecoveryQuestion = (id, api_token, currentPassword, recoveryQuestion, recoveryAnswer) => {
  const data = {
    password: { value: currentPassword },
    recovery_question: {
      question: recoveryQuestion,
      answer: recoveryAnswer
    }
  }
  const config = {
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `SSWS ${api_token}`
    }
  }
  return req.post(`/users/me/${id}/credentials/change_recovery_question`, data, config)
}
